
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M5.34982 5.64C4.44982 5 4.22982 3.76 4.85982 2.85C5.48982 1.95 6.73982 1.73 7.64982 2.36C8.54982 3 8.76982 4.24 8.13982 5.15C7.49982 6.05 6.25982 6.27 5.34982 5.64ZM15.9998 20C15.9998 19.45 15.5498 19 14.9998 19H8.92982C7.44982 19 6.18982 17.92 5.96982 16.46L4.15982 7.78C4.06982 7.33 3.66982 7 3.19982 7C2.57982 7 2.11982 7.57 2.23982 8.18L3.98982 16.76C4.36982 19.2 6.46982 21 8.93982 21H14.9998C15.5498 21 15.9998 20.55 15.9998 20ZM15.5398 15H11.3498L10.3198 10.9C11.5998 11.62 12.9498 12.18 14.4198 12.2C14.9998 12.21 15.4698 11.71 15.4698 11.13C15.4698 10.54 14.9798 10.09 14.3898 10.07C13.0798 10.03 11.7598 9.51 10.7798 8.74L9.13982 7.47C8.90982 7.29 8.64982 7.17 8.37982 7.09C8.05982 7 7.71982 6.97 7.38982 7.03H7.36982C6.13982 7.25 5.31982 8.42 5.52982 9.64L6.87982 15.56C7.15982 16.98 8.38982 18 9.82982 18H16.6798L19.7698 20.42C20.1898 20.75 20.7898 20.71 21.1598 20.34C21.6098 19.89 21.5598 19.16 21.0598 18.77L16.7698 15.42C16.4198 15.15 15.9898 15 15.5398 15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-airline-seat-recline-extra`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAirlineSeatReclineExtra

    ```js
    <b-new-b-icon-airline-seat-recline-extra />
    ```
</docs>


